import React, {useEffect, useState} from 'react';

import Banner from 'web/components/banner';
import segmentAnalytics from '@analytics/client';
import assetPath from 'web/helpers/asset_path';

export const BANNER_PATH = '/summer ';

interface HomeBannerProps {
  minWidth?: number;
  noMargin?: boolean;
}
const HomeBanner: React.FC<HomeBannerProps> = ({minWidth = 720, noMargin}) => {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : minWidth);
  const handleClickCard = (): void => {
    segmentAnalytics.track('ctaClicked', {
      type: 'banner',
      text: 'Shop the offer now.',
      pageUrl: window.location.pathname,
      destination: `${BANNER_PATH}?utm_source=banner&utm_medium=site&utm_campaign=summer`,
    });
    window.location.assign(BANNER_PATH);
  };

  useEffect(() => {
    const handleResize = (): void => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <div className="basket-view__header home-banner" style={{margin: noMargin ? 0 : '0 auto'}}>
      <Banner
        variant="summer"
        imgSource={
          <img
            alt="Banner logo"
            data-testid="banner-logo"
            src={`${assetPath('/img/svg/icons/banner-summer-icon.svg')}?auto=format`}
            className="banner__icon"
            style={{cursor: 'pointer'}}
            onClick={handleClickCard}
          />
        }
        title={
          <p data-testid="banner-title">
            Celebrate every summer moment with{' '}
            <span className="banner_highlight"> $150 off across 5 orders</span>. Use code{' '}
            <span className="banner_highlight banner_higlight_promocode">SUMMER25</span> at
            checkout.
            <span className="small-space"> </span>
            {width < minWidth && <br />}
            <a
              href={BANNER_PATH}
              className="banner_higlight_promocode banner_cta"
              data-testid="cta-link"
            >
              Shop the offer now.
            </a>
          </p>
        }
        showInfoButton={false}
      />
    </div>
  );
};

export default HomeBanner;
